import React from 'react';

import { StyleSheet, View } from 'react-native';
import { useWindowDimensions } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const BOTTOM_SHEET_MAX_HEIGHT_RATIO = 0.9;

/**
 * Keyboard-aware content wrapper for BottomSheet that handles keyboard appearance.
 * Use this when the bottom sheet contains form inputs that need to stay visible
 * when the keyboard appears.
 */
export const KeyboardAwareBottomSheetContent: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const insets = useSafeAreaInsets();
  const { height: windowHeight } = useWindowDimensions();
  const maxHeight = windowHeight * BOTTOM_SHEET_MAX_HEIGHT_RATIO - insets.top;

  return (
    <View style={styles.content}>
      <KeyboardAwareScrollView
        style={[styles.scrollView, { maxHeight }]}
        contentContainerStyle={styles.scrollContent}
        keyboardShouldPersistTaps="handled"
      >
        {children}
      </KeyboardAwareScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  content: {
    flexShrink: 1,
    width: '100%',
  },
  scrollView: {
    width: '100%',
  },
  scrollContent: {
    flexGrow: 1,
    width: '100%',
  },
});
